import React from 'react';

class GameHUD extends React.Component {
    render() {
        const { score, combo, wave, timeRemaining, levelName, paused, onPause, onQuit, isTutorial, tutorialHitCount } = this.props;

        // Progressive HUD reveal for Level 1 tutorial
        const showScore = !isTutorial || tutorialHitCount >= 1;
        const showCombo = !isTutorial || tutorialHitCount >= 5;
        const showWave = !isTutorial || tutorialHitCount >= 8;

        const isTimedMode = timeRemaining !== null && timeRemaining !== undefined;

        return (
            <div className="game-hud" data-testid="game-hud">
                {/* Top bar */}
                <div className="game-hud-top">
                    <div className="game-hud-left">
                        {showScore && (
                            <div className="game-score" data-testid="score-display">
                                {score.toLocaleString()}
                            </div>
                        )}
                    </div>
                    <div className="game-hud-center">
                        {showCombo && combo > 0 && (
                            <div
                                className={`game-combo ${combo >= 10 ? 'combo-fire' : ''}`}
                                data-testid="combo-display"
                            >
                                {combo}x
                            </div>
                        )}
                    </div>
                    <div className="game-hud-right">
                        <button
                            className="pause-button"
                            data-testid="pause-button"
                            onClick={onPause}
                            aria-label="Pause"
                        >
                            {paused ? '▶' : '▐▐'}
                        </button>
                    </div>
                </div>

                {/* Timer for timed modes (Endless / Daily) */}
                {isTimedMode && (
                    <div className="game-timer" data-testid="game-timer">
                        <span className={timeRemaining <= 10 ? 'timer-urgent' : ''}>
                            {Math.ceil(timeRemaining)}s
                        </span>
                    </div>
                )}

                {/* Wave progress bar (campaign levels only) */}
                {!isTimedMode && showWave && wave && (
                    <div className="game-wave-bar">
                        <div
                            className="game-wave-fill"
                            style={{ width: `${(wave.index / wave.total) * 100}%` }}
                        />
                    </div>
                )}

                {/* Bottom info */}
                {showWave && (
                    <div className="game-hud-bottom">
                        {!isTimedMode && wave && (
                            <span>Wave {wave.index + 1}/{wave.total + 1}</span>
                        )}
                        <span>{levelName}</span>
                    </div>
                )}

                {/* Pause overlay */}
                {paused && (
                    <div className="pause-overlay" data-testid="pause-overlay">
                        <div className="pause-content">
                            <div className="pause-title">Paused</div>
                            <button className="pause-resume-btn" onClick={onPause}>Resume</button>
                            <button className="pause-quit-btn" onClick={onQuit}>Quit</button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default GameHUD;
